import React from 'react'
import { useTranslation } from 'react-i18next'

import Horizon from '../../../layout/Footer/Horizon'
import Steps from '../../../pages/vouchers/Steps'

import Styles from './styles'

const riparideVoucherXmas =
  'https://assets.riparide.com/landing_pages/vouchers_christmas/riparide_voucher_xmas_1_15-12-2021.png'
const advImage =
  'https://assets.riparide.com/landing_pages/vouchers_christmas/adv_image_17-12-2021.png'
const fulImage =
  'https://assets.riparide.com/landing_pages/vouchers_christmas/ful_image_15-12-2021.png'

const XmasLandingPage = () => {
  const [t] = useTranslation('spelling')

  return (
    <>
      <Styles>
        <div id="wrapper">
          <div id="intro">
            <div className="tophead">
              <h1>Riparide Christmas Vouchers</h1>
              <p>
                A Riparide Christmas Voucher is the ultimate &quot;choose your
                own adventure&quot;. Our Riparide vouchers can be used to book
                any escape, whether it&apos;s a wilderness cabin or a beach
                retreat, we&apos;ve got a local escape to suit every stoke
                style.
              </p>
              <a href="/vouchers/create" className="buybutton">
                Buy a Riparide Voucher
              </a>
            </div>
          </div>

          <Horizon />

          <div className="bkg_all">
            <div id="main">
              <section className="two_column">
                <article className="text_block">
                  <div className="container_text">
                    <div>
                      <span className="subtitle">Escape the ordinary</span>
                      <h3>Get out of town and into nature</h3>
                      <p>
                        A gift for anyone who loves exploring, adventure and
                        escaping the daily grind.
                      </p>
                      <a href="/vouchers/create">Buy a Riparide Voucher</a>
                    </div>
                  </div>
                </article>
                <article className="cover right">
                  <a href="/vouchers/create">
                    <img src={riparideVoucherXmas} alt="" />
                  </a>
                </article>
              </section>

              <section className="two_column">
                <article className="text_block">
                  <div className="container_text">
                    <div>
                      <span className="subtitle">Adventure unlocked</span>
                      <h3>Choose their own adventure</h3>
                      <p>
                        From beach escapes and hidden waterfalls to snowy
                        mountain cabins, a Riparide Christmas voucher will suit
                        every adventure style.
                      </p>
                      <a href="/vouchers/create">Buy a Riparide Voucher</a>
                    </div>
                  </div>
                </article>
                <article className="cover right">
                  <a href="/voucher/create">
                    <img src={advImage} alt="" />
                  </a>
                </article>
              </section>

              <section className="two_column">
                <article className="text_block">
                  <div className="container_text">
                    <div>
                      <span className="subtitle">Soul-fulfilling moments</span>
                      <h3>Memories last longer</h3>
                      <p>
                        More than just a getaway – by gifting someone a Riparide
                        voucher you&apos;re giving them memories to last and
                        moments to love.
                      </p>
                      <a href="/voucher/create">Buy a Riparide Voucher</a>
                    </div>
                  </div>
                </article>
                <article className="cover right">
                  <a href="/voucher/create">
                    <img src={fulImage} alt="" />
                  </a>
                </article>
              </section>
            </div>
          </div>

          <div className="points_wrapper">
            <h3>Give the Gift of Adventure</h3>

            <Steps />

            <a href="/voucher/create" className="buybutton no-top-margin">
              Buy a Riparide Voucher
            </a>
          </div>

          <div className="points_wrapper seo">
            <h4>Riparide Christmas Voucher</h4>
            <p>
              A Riparide Christmas Voucher is the ultimate &quot;choose your own
              adventure&quot;. You don&apos;t need to rely on Santa to give your
              friends/family/lover/{t('neighbor')} the gift of adventure this
              Christmas. Our Riparide vouchers can be used to book any escape
              and are valid for three years from the date of purchase. You can
              even include a personalised message for the lucky recipient.
              There&apos;s never been a better time to help a loved one escape
              the city, get out into nature and find fulfilment. Whether
              it&apos;s a wilderness cabin or a beach retreat, we&apos;ve got a
              local escape to suit every stoke style. More than just your
              regular Christmas gift voucher, when you gift Riparide you&apos;re
              giving someone memories to last and moments to love.
            </p>

            <div className="points">
              <div className="point">
                <a
                  href="https://pages.riparide.com/employee-vouchers"
                  className=""
                >
                  Employee vouchers
                </a>
              </div>

              <div className="point">
                <a href="/stories-travellers" className="">
                  Riparide Stories
                </a>
              </div>

              <div className="point">
                <a href="/listings" className="">
                  Browse Escapes
                </a>
              </div>

              <div className="point">
                <a href="/about" className="">
                  About us
                </a>
              </div>
            </div>
          </div>
        </div>
      </Styles>
    </>
  )
}

export default XmasLandingPage
